import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { SubscriptionLike } from 'rxjs';
import { TEMPLATE_ACTIVATION_ENUM } from '../../../../../shared/enums/template-activation.enum';
import { EmailService } from '../../../../services/email.service';
import { ErrorMessageService } from '../../../../../shared/error-message.service';

@Component({
  selector: 'app-mail-templates-activation',
  templateUrl: './mail-templates-activation.component.html',
  styleUrls: ['./mail-templates-activation.component.scss'],
})
export class MailTemplatesActivationComponent implements OnInit, OnDestroy {
  @Input() id: number;
  @Input() enabled: boolean = false;
  @Input() type: TEMPLATE_ACTIVATION_ENUM;

  @Output() activated = new EventEmitter<any>();

  isSending = false;
  subscriber: SubscriptionLike;

  constructor(
    private emailService: EmailService,
    private errorMessage: ErrorMessageService
  ) {}

  ngOnInit(): void {}
  ngOnDestroy() {
    if (this.subscriber) {
      this.subscriber.unsubscribe();
    }
  }

  onClick() {
    if (this.id && this.type) {
      this.isSending = true;

      this.subscriber = this.emailService
        .emailTemplatesActivation(this.id, this.type, this.enabled)
        .subscribe(
          (response) => {
            this.enabled = response.enabled;
            this.errorMessage.showSuccess('Saved Successuly');
            this.isSending = false;
            this.activated.emit(response);
          },
          (error) => {
            this.errorMessage.showError(
              error?.error?.error?.details,
              'Save Failed'
            );

            this.isSending = false;
          }
        );
    }
  }
}
